const PrescriptionType = {
  MELATONIN: 1,
  ERECTILY_DYSFUNCTION: 2,
  HAIR_LOSS: 3,
  PRECOCIOUS: 4,
  WELLNESS: 5,
  WEIGHT_LOSS: 6,
};

export default PrescriptionType;